import { useMutation } from '@tanstack/react-query';
import { baixarXmlNfse } from '../api/BaixarXmlNfseApi';

interface BaixarXmlNfseVariaveis {
  chaveAcessoDoc: string;
  cnpjContribuinte?: string | null;
}

export function useBaixarXmlNfse() {
  return useMutation<{ arquivo: Blob; nome: string }, Error, BaixarXmlNfseVariaveis>({
    mutationFn: ({ chaveAcessoDoc, cnpjContribuinte }) =>
      baixarXmlNfse(chaveAcessoDoc, cnpjContribuinte),
  });
}
